/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Conoce gente nueva, chatea, queda",
      "Número de teléfono incorrecto",
      "Descargar la app",
      "Continuar con Apple",
      "Continuar con Facebook",
      "Continuar con Google",
      "Iniciar sesión",
      "Registrarme",
      "Para continuar por favor introduce los caracteres que vez en el recuadro",
      "Continuar",
      "Introducir caracteres",
      "Control de seguridad",
      "Recargar",
      "Crea una contraseña nueva que recuerdes fácilmente.",
      "Actualizar",
      "Confirmar contraseña",
      "La contraseña debe tener al menos {{num}} [[characters:num]]",
      "Contraseña",
      "Crear contraseña nueva",
      "Badoo - El Blog",
      "Empleo",
      "Chat",
      "Ciudades",
      "Administrar cookies",
      "Copyright © 2006 – presente. Bumble. Todos los derechos reservados.",
      "Apple y el logo de Apple son marcas comerciales de Apple Inc. {{__EOL__}}Google Play es una marca de Google LLC. ",
      "Descargar",
      "Facebook",
      "Síguenos",
      "Centro de soporte",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Resumen",
      "Badoo es parte de Bumble Inc.",
      "Política de Privacidad",
      "Centro de Seguridad",
      "Mapa del sitio",
      "Declaración del Modern Slavery Act",
      "Términos y condiciones",
      "Twitter",
      "Introduce tu email o número telefónico y te enviaremos instrucciones para crear una contraseña nueva.",
      "Obtener contraseña nueva",
      "Introduce tu email o número telefónico",
      "Contraseña olvidada",
      "Modelos usados para propósitos ilustrativos solamente",
      "Descargar la app",
      "Queremos ofrecerte un apoyo más amplio, tecnología más útil y experiencias más seguras para promover las relaciones basadas en la confianza. Todo esto responde al compromiso de Badoo de ser la aplicación que fomenta la confianza en las citas.",
      "Seguiremos desarrollando tecnologías pioneras que satisfagan las necesidades de los usuarios identificadas en este informe, empezando por el lanzamiento de \"<b><a href=\"{{url}}\">Deception Detector™</a></b>\", un modelo de aprendizaje automático que ofrece una <b>precisión del 99,5 %</b> en la lucha contra el spam, las estafas y las cuentas falsas.",
      "Nos <b>comprometemos</b> a hacer un uso responsable de la inteligencia artificial (IA), a priorizar la inteligencia humana y a evitar que las capacidades de la IA afecten a la <b>autenticidad</b> de nuestra comunidad;",
      "No contribuiremos a crear tendencias en materia de citas que fomenten <b>percepciones</b> y <b>comportamientos negativos</b>;",
      "Trabajaremos para detectar <b>malos comportamientos</b> en el ámbito de las citas, a fin de minimizar su impacto en el bienestar de nuestra comunidad;",
      "Solo trabajaremos con personas influyentes que nos parezcan <b>auténticas</b> y <b>reales</b> a la hora de mostrarse en Internet;",
      "Ir a Badoo",
      "Nuestros Compromisos de confianza:",
      "Hemos publicado este informe para que los usuarios, las comunidades de aplicaciones de citas y las plataformas en línea puedan servirse de sus conclusiones con el fin de ayudar a la gente a tener una experiencia más positiva, agradable y con más posibilidades que nunca.",
      "En Badoo sabemos que aún queda mucho por hacer. Nuestros equipos han analizado los resultados y están realizando cambios para aportar nuestro granito de arena. Asimismo, hemos decidido asumir algunos compromisos de forma inmediata.",
      "En este momento crucial, en el que creemos que la conexión humana es más necesaria que nunca y en el que es tan importante que las personas confíen en su capacidad para establecer vínculos, hemos creado el primer <b>Informe sobre la confianza en las citas del sector</b>.",
      "Descargar el informe",
      "Badoo siempre ha sido pionera en el ámbito de las citas, ya que creó una de las primeras plataformas de citas en línea del mundo y fue la primera en alcanzar los 100 millones de descargas.",
      "El informe recoge los comportamientos, actitudes y tendencias que han influido negativamente en el ámbito de las citas y ofrece consejos de especialistas sobre cómo disfrutar al máximo de las partes buenas y cómo gestionar (o cambiar) las partes que preferiríamos evitar.",
      "Practicar la atención consciente: relajarte, estar presente y mostrarte tal y como eres en tus citas, tanto en Internet como en la vida real.",
      "Ser capaz de ignorar lo que ves en las redes sociales y centrarte en lo que te va bien a título personal;",
      "Sentir que puedes confiar en que la persona que ves o con la que hablas es real;",
      "Tener claras tus intenciones y confiar en que tus matches también sean honestos;",
      "Reducir la paranoia y la hipervigilancia ante comportamientos negativos en las citas;",
      "Las claves para tener más confianza en las citas son:",
      "Creemos que esta es la mayor barrera a la que se enfrenta el sector de las citas, y nuestro compromiso para romperla ya es una realidad. Cada año, en lugar de centrarnos en las tendencias del mercado del dating, haremos un seguimiento de nuestro propio progreso para fomentar la confianza en las citas y seguiremos evaluando los retos a los que se enfrentan los usuarios de todo el sector.",
      "Los resultados darán lugar a Compromisos de confianza anuales y a innovaciones en nuestro servicio para ayudar a minimizar las experiencias negativas que dañan la confianza de la gente. En última instancia, esto ayudará a hacer de las citas online una experiencia más amable, <b><u><a href=\"{{url}}\">segura</a></u></b> y valiosa para quienes buscan conexiones significativas. A continuación encontrarás nuestros compromisos para 2024.",
      "Leer Compromisos de confianza",
      "El informe pone de manifiesto que la confianza en las citas está bajo mínimos para muchas personas solteras.",
      "No tienes que esperar un match.{{__EOL__}}{{__EOL__}}Puedes empezar a chatear directamente para tener conversaciones más profundas y pasar a lo bueno: conocerse de verdad.",
      "¿Listo para chatear?",
      "Al registrarte, aceptas nuestros <a class=\"link\" href=\"{{terms_url}}\"> Términos y Condiciones</a>.Conoce cómo usamos tus datos en nuestra <a class=\"link\" href=\"{{privacy_url}}\">Política de Privacidad</a>",
      "Ayudándote a mostrarte tal como eres, <br />para tener citas con las que te sientas a gusto.",
      "Tu espacio seguro para conocer gente.",
      "O",
      "¿Ya tienes una cuenta?",
      "Regístrate con tu email o número telefónico",
      "Obtén lo que quieres de las citas.{{__EOL__}}No hay necesidad de disculparse.",
      "¿Sólo quieres chatear? Está bien.{{__EOL__}}¿Quieres sentar cabeza?Genial.{{__EOL__}}{{__EOL__}}Y si cambias de opinión no hay ningún problema.",
      "Para tener citas",
      "Busco una relación",
      "Abierto a chatear",
      "Conoce gente que quiere lo mismo.",
      "{{name}}, {{age}}",
      "Tu seguridad es nuestra prioridad número uno.",
      "En nuestro Centro de Seguridad encontrarás todo el apoyo que necesitas para tener citas seguras.",
      "Visita el Centro de Seguridad",
      "La Seguridad primero,<br/>segundo y siempre.",
      "Desde el primer momento supe que iba a funcionar...",
      "Al principio no buscaba nada serio...",
      "El consejo para cualquiera que en la App de Badoo es que sea auténtico...",
      "Historias de éxito de Badoo",
      "Ver más historias de éxito",
      "{{num}}__CUT__Rating",
      "Apple App Store",
      "Confía en nosotros. Hemos juntado millones (y milliones, y milliones) de gente desde 2006.",
      "Más de {{num}}M__CUT__de descargas",
      "{{num}}M+",
      "Google Play Store",
      "Sabemos lo que estamos haciendo.",
      "Entra con tu email o número telefónico",
      "Introduce tu contraseña",
      "¿Olvidaste tu contraseña?",
      "Registrarse",
      "¿No tienes una cuenta?",
      "Entrar",
      "Registrarse"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "carácteres"
            ],
            "singular": [
                  "carácter"
            ]
      },
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
